
// Authentication Request Models
export class LoginRequestDto {
  public email!: string;
  public password!: string;
  constructor(init?: Partial<LoginRequestDto>) { Object.assign(this, init); }
}

export class RefreshTokenRequestDto {
  public userId!: string; // Guid serialized as string
  public refreshToken!: string;
  constructor(init?: Partial<RefreshTokenRequestDto>) { Object.assign(this, init); }
}

// Authentication Response Models
export class TokenResponseDto {
  public accessToken!: string;
  public refreshToken!: string;
  constructor(init?: Partial<TokenResponseDto>) { Object.assign(this, init); }
}

// Claims Response Model
export class ClaimsResponse {
  public userId!: string;
  public email!: string;
  public username!: string;
  public fName!: string;
  public lName!: string;
  public role!: string;
  public allClaims!: Claim[];
  constructor(init?: Partial<ClaimsResponse>) { Object.assign(this, init); }
}

export class Claim {
  public type!: string;
  public value!: string;
  constructor(init?: Partial<Claim>) { Object.assign(this, init); }
}

export class UserFriendlyException {
  public message!: string;
  public type!: string;
  constructor(init?: Partial<UserFriendlyException>) { Object.assign(this, init); }
}

export class ChangePasswordRequestDto {
  public userId!: string;
  public currentPassword!: string;
  public newPassword!: string;
  constructor(init?: Partial<ChangePasswordRequestDto>) { Object.assign(this, init); }
}

export class PasswordResetResponseDto {
  public isSuccess!: boolean;
  public message!: string;
  constructor(init?: Partial<PasswordResetResponseDto>) { Object.assign(this, init); }
}

export class PagedResultDto<T> {
  public items!: T[];
  public totalCount!: number;
  public pageNumber!: number;
  public pageSize!: number;
  public totalPages!: number;
  public hasPreviousPage!: boolean;
  public hasNextPage!: boolean;

  constructor(init?: Partial<PagedResultDto<T>>) {
    Object.assign(this, init);
  }
}